import { bindable, bindingMode, PLATFORM, useView } from 'aurelia-framework';
import { ProgressBar } from '~/components/progress-bar/progress-bar';

@useView(PLATFORM.moduleName('./benefits-payments-batch-progress.html'))
export class BenefitsPaymentsBatchProgress {
	@bindable
	private slideoutProgressBar: ProgressBar;
	@bindable
	private showResumeButton: boolean;
	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	private onResumeButtonClick?: () => void;
}
